
import React from "react";
import PropTypes from "prop-types";

import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import '../../css/ChartAlgo.css';

import { ChartCanvas, Chart, ZoomButtons } from "react-stockcharts";
import {
	CandlestickSeries,
	LineSeries,
	BarSeries,
	RSISeries,
	BollingerSeries,
	MACDSeries,
	StochasticSeries,
	SARSeries
} from "react-stockcharts/lib/series";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import {
	CrossHairCursor,
	EdgeIndicator,
	CurrentCoordinate,
	MouseCoordinateX,
	MouseCoordinateY,
} from "react-stockcharts/lib/coordinates";

import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";
import {
	OHLCTooltip,
	MovingAverageTooltip,
	RSITooltip,
	SingleValueTooltip,
	BollingerBandTooltip,
	MACDTooltip,
	StochasticTooltip
} from "react-stockcharts/lib/tooltip";
import { ema, sma, rsi, atr, bollingerBand, macd, stochasticOscillator,sar } from "react-stockcharts/lib/indicator";
import { fitWidth } from "react-stockcharts/lib/helper";
// import algo from "react-stockcharts/lib/algorithm";
import {
	// Label,
	Annotate,
	SvgPathAnnotation,
	buyPath,
	sellPath,
	LabelAnnotation,
} from "react-stockcharts/lib/annotation";
import { last } from "react-stockcharts/lib/utils";
import PubSub from 'pubsub-js';
import { TrendLine } from "react-stockcharts/lib/interactive";
import { PriceCoordinate } from "react-stockcharts/lib/coordinates";
import { getSupportResistance } from '../../service/SupportResistance';
import { getTrendLine } from '../../service/Trendline';
import { calculateAndBestStratergy } from '../../service/Stratergy';

const bbStroke = {
	top: "#964B00",
	middle: "#000000",
	bottom: "#964B00",
};
const bbFill = "#4682B4";

const macdAppearance = {
	stroke: {
		macd: "#00F300",
		signal: "#FF0000",
	},
	fill: {
		divergence: "#4682B4"
	},
};

const mouseEdgeAppearance = {
	textFill: "#542605",
	stroke: "#05233B",
	strokeOpacity: 1,
	strokeWidth: 3,
	arrowWidth: 5,
	fill: "#BCDEFA",
};

const stoAppearance = {
	stroke: {
		dLine: "#FF0000",
		kLine: "#00F300"
	}
};

const sarAppearance = {
	fill: {
		falling: "#ff0000",
		rising: "#00ff00"
	},
	highlightOnHover: false
};

class ChartAlgo extends React.Component {
	constructor(props) {
		console.log('Initializing chartalgo', props);
		super(props);
		this.state = {
			reload: false,

			rsiIndicator: true,
			atrIndicator: false,
			macdIndicator: true,
			emaIndicator: false,
			maIndicator: false,
			bbIndicator: false,
			smaIndicator: false,
			fullStoIndicator: false,
			sarIndicator: false,

			emaStratergy: false,
			rsiStratergy: false,
			macdStratergy: false,
			smaStratergy: false,
			//data: calculateAndBestStratergy(this.props.data),
			data: this.props.data,
			supResLevels: getSupportResistance(this.props.data),
			trendLineLevels: getTrendLine(this.props.data),

			autoDrawSupRes: true,
			autoDrawTrend: true,

		};
		this.emaLowValue = 13;
		this.emaHighValue = 50;

		this.smaLowValue = 10;
		this.smaHighValue = 20;
		this.handleReset = this.handleReset.bind(this);

		this.emaStratergy = false;
		this.rsiStratergy = false;
		this.macdStratergy = false;
		this.smaStratergy = false;

	}

	componentWillMount() {
		this.setState({
			suffix: 1
		});
	}

	componentDidMount() {
		this.chartIndicatorsTrigger = PubSub.subscribe('chartIndicatorsSelected', (topic, data) => {
			console.log('AlgoTrade chartIndicatorsSelected Received data', data);
			this.updateIndicator(data);
		});

		this.chartAlgorithmTrigger = PubSub.subscribe('chartAlgorithmsSelected', (topic, data) => {
			console.log('AlgoTrade chartAlgorithmsSelected Received data', data);
			this.updateAlgorithm(data);
		});

		this.chartAlgorithmTrigger = PubSub.subscribe('autoDrawSelected', (topic, data) => {
			console.log('AlgoTrade autoDrawSelected Received data', data);
			this.autoDrawSelected(data);
		});

		this.chartRefreshTrigger = PubSub.subscribe('chartRefresh', (topic, obj) => {
			console.log('AlgoTrade chartRefresh Received data', obj, this.props);
			this.setState({
				data: obj.data,
				supResLevels: getSupportResistance(this.state.data),
				trendLineLevels: getTrendLine(this.state.data),
				//reload: true, 
			}, () => {
				if (obj !== undefined && obj.selectedAlgo !== undefined && obj.selectedAlgo.target !== undefined) {
					this.updateAlgorithm([obj.selectedAlgo.target]);
				}
			});
		});
	}

	componentWillUnmount() {
		PubSub.unsubscribe(this.chartIndicatorsTrigger);
		PubSub.unsubscribe(this.chartAlgorithmTrigger);
		PubSub.unsubscribe(this.chartRefreshTrigger);
	}

	updateIndicator = (data) => {
		if (!(data !== undefined && data.length !== undefined && data.length > 0)) {
			return;
		}
		let tmpRsiSelected = false;
		let tmpAtrSelected = false;
		let tmpMacdSelected = false;
		let tmpEmaSelected = false;
		let tmpSmaSelected = false;
		let tmpBbSelected = false;
		let tmpFullStoSelected = false;
		let tmpSarSelected = false;
		for (var i = 0; i < data.length; i++) {
			if (data[i].name.toLowerCase() === 'rsi') {
				tmpRsiSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'atr') {
				tmpAtrSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'macd') {
				tmpMacdSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'ema') {
				tmpEmaSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'sma') {
				tmpSmaSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'bb') {
				tmpBbSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'fullsto') {
				tmpFullStoSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'sar') {
				tmpSarSelected = data[i].selected;
			}			
		}

		this.setState({
			rsiIndicator: tmpRsiSelected, atrIndicator: tmpAtrSelected,
			macdIndicator: tmpMacdSelected, emaIndicator: tmpEmaSelected,
			smaIndicator: tmpSmaSelected, bbIndicator: tmpBbSelected,
			fullStoIndicator: tmpFullStoSelected, sarIndicator: tmpSarSelected,
			supResLevels: getSupportResistance(this.state.data),
			reload: true
		});
	}

	updateAlgorithm = (data) => {
		if (!(data !== undefined && data.length !== undefined && data.length > 0)) {
			return;
		}
		let tmpRsiSelected = false;
		let tmpAtrSelected = false;
		let tmpMacdSelected = false;
		let tmpEmaSelected = false;
		let tmpSmaSelected = false;
		let tmpBbSelected = false;

		let tmpEmaIndicatorSelected = false;
		let tmpSmaIndicatorSelected = false;
		for (var i = 0; i < data.length; i++) {
			if (data[i].name.toLowerCase() === 'rsi') {
				tmpRsiSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'atr') {
				tmpAtrSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'macd') {
				tmpMacdSelected = data[i].selected;
			}
			if (data[i].name.toLowerCase() === 'ema') {
				tmpEmaSelected = data[i].selected;
				tmpEmaIndicatorSelected = true;
			}
			if (data[i].name.toLowerCase() === 'sma') {
				tmpSmaSelected = data[i].selected;
				tmpSmaIndicatorSelected = true;
			}
			if (data[i].name.toLowerCase() === 'bb') {
				tmpBbSelected = data[i].selected;
			}
		}

		this.emaStratergy = tmpEmaSelected;
		this.rsiStratergy = tmpRsiSelected;
		this.macdStratergy = tmpMacdSelected;
		this.smaStratergy = tmpSmaSelected;

		this.setState({
			rsiStratergy: tmpRsiSelected, macdStratergy: tmpMacdSelected,
			emaStratergy: tmpEmaSelected, smaStratergy: tmpSmaSelected,

			emaIndicator: tmpEmaIndicatorSelected,
			smaIndicator: tmpSmaIndicatorSelected,

			supResLevels: getSupportResistance(this.state.data),
			trendLineLevels: getTrendLine(this.state.data),
			reload: true
		});
	}

	autoDrawSelected = (data) => {
		let tmpSupResSelected = false;
		let tmpTrendSelected = false;
		for (var i = 0; i < data.length; i++) {
			if (data[i].name === 'supRes') {
				tmpSupResSelected = data[i].selected;
			}
			if (data[i].name === 'trend') {
				tmpTrendSelected = data[i].selected;
			}

		}

		this.setState({
			autoDrawSupRes: tmpSupResSelected,
			autoDrawTrend: tmpTrendSelected,
			supResLevels: getSupportResistance(this.state.data),
			trendLineLevels: getTrendLine(this.state.data),
			reload: true
		});
	}

	getChartCanvasHeight() {
		let height = 400;
		if (this.state.rsiIndicator) {
			height = height + 100;
		}
		if (this.state.atrIndicator) {
			height = height + 100;
		}
		if (this.state.macdIndicator) {
			height = height + 300;
		}
		console.log('Chart Canvas height', height);
		return height;
	}

	handleReset() {
		this.setState({
			suffix: this.state.suffix + 1
		});
	}

	filterAlgoData(origData) {
		let data = origData.data;
		let tmpList = [];
		for (var i = 0; i < data.length; i++) {
			if (data[i].emaLongShort !== undefined) {
				tmpList.push(data[i]);
			}
			if (data[i].smaLongShort !== undefined) {
				tmpList.push(data[i]);
			}
			if (data[i].macdLongShort !== undefined) {
				tmpList.push(data[i]);
			}
			if (data[i].rsiLongShort !== undefined) {
				tmpList.push(data[i]);
			}
		}
		return { data: tmpList, profitList: origData.profitList };
	}

	renderSupRes(listValue) {
		if (listValue !== undefined) {
			let noOfDecimals = '.2f';
			if (listValue < 1) { noOfDecimals = '.5f'; }
			return (
				<PriceCoordinate at="left" orient="left" key={Math.random()} price={listValue} lineOpacity={0.5} strokeDasharray="ShortDash" displayFormat={format(noOfDecimals)} />
			)
		}
	}

	renderTrendLineLevels(listValue) {
		if (listValue !== undefined) {
			let adjust = listValue.adjust;
			console.log('trendline adjust', adjust);
			let highTrends = [
				{ start: [listValue.highTrend[0][0], listValue.highTrend[0][1] + adjust], end: [listValue.highTrend[1][0], listValue.highTrend[1][1] + adjust], appearance: { stroke: "red" }, type: "LINE" }
			];
			let lowTrends = [
				{ start: [listValue.lowTrend[0][0], listValue.lowTrend[0][1] - adjust], end: [listValue.lowTrend[1][0], listValue.lowTrend[1][1] - adjust], appearance: { stroke: "green" }, type: "LINE" }
			];
			return (
				<>
					<TrendLine
						enabled={false}
						snap={false}
						hoverText={{ enable: false }}
						trends={highTrends}
					/>
					<TrendLine
						enabled={false}
						snap={false}
						hoverText={{ enable: false }}
						trends={lowTrends}
					/>
				</>

			)
		}
	}

	render() {
		if (this.state === null || this.state.data === undefined) {
			return <div>Loading...</div>
		}

		if (this.state.data !== undefined && this.state.data.length <= 0) {
			return <div>No Data</div>
		}

		if (this.state.reload) {
			console.log('ChartAlgo Reloading...');
			this.setState({ reload: false });
			return <div>Loading...</div>;
		}

		const { type, data: initialData, width, ratio } = this.props;

		const smaLow = sma()
			.id(0)
			.options({ windowSize: this.smaLowValue })
			.merge((d, c) => { d.smaLow = c; })
			.accessor(d => d.smaLow);

		const smaHigh = sma()
			.id(2)
			.options({ windowSize: this.smaHighValue })
			.merge((d, c) => { d.smaHigh = c; })
			.accessor(d => d.smaHigh);

		const emaLow = ema()
			.id(0)
			.options({ windowSize: this.emaLowValue })
			.merge((d, c) => { d.emaLow = c; })
			.accessor(d => d.emaLow);

		const emaHigh = ema()
			.id(2)
			.options({ windowSize: this.emaHighValue })
			.merge((d, c) => { d.emaHigh = c; })
			.accessor(d => d.emaHigh);

		const rsiCalculator = rsi()
			.options({ windowSize: 14 })
			.merge((d, c) => { d.rsi = c; })
			.accessor(d => d.rsi);

		const atr14 = atr()
			.options({ windowSize: 14 })
			.merge((d, c) => { d.atr14 = c; })
			.accessor(d => d.atr14);

		const bb = bollingerBand()
			.merge((d, c) => { d.bb = c; })
			.accessor(d => d.bb);

		const macdCalculator = macd()
			.options({
				fast: 12,
				slow: 26,
				signal: 9,
			})
			.merge((d, c) => { d.macd = c; })
			.accessor(d => d.macd);

		const fullSTO = stochasticOscillator()
			.options({ windowSize: 14, kWindowSize: 3, dWindowSize: 4 })
			.merge((d, c) => { d.fullSTO = c; })
			.accessor(d => d.fullSTO);

		const sarAccelerationFactor = .02;
		const sarMaxAccelerationFactor = .2;
		const defaultSar = sar()
			.options({
				sarAccelerationFactor, sarMaxAccelerationFactor
			})
			.merge((d, c) => { d.sar = c; })
			.accessor(d => d.sar);


		const defaultAnnotationProps = {
			onClick: console.log.bind(console),
		};

		const longAnnotationProps = {
			...defaultAnnotationProps,
			y: ({ yScale, datum }) => yScale(datum.low),
			fill: "#006517",
			path: buyPath,
			tooltip: "Go long",
		};

		const shortAnnotationProps = {
			...defaultAnnotationProps,
			y: ({ yScale, datum }) => yScale(datum.high),
			fill: "#FF0000",
			path: sellPath,
			tooltip: "Go short",
		};

		const margin = { left: 80, right: 80, top: 30, bottom: 50 };
		const height = 600;
		//const height = this.getChartCanvasHeight();

		// const [yAxisLabelX, yAxisLabelY] = [width - margin.left - 40, margin.top + (height - margin.top - margin.bottom) / 2];
		// const emaStratergy = this.state.emaStratergy; 
		// const macdStratergy = this.state.macdStratergy;
		// const rsiStratergy = this.state.rsiStratergy;
		// const smaStratergy = this.state.smaStratergy;
		const emaStratergy = this.emaStratergy;
		const macdStratergy = this.macdStratergy;
		const rsiStratergy = this.rsiStratergy;
		const smaStratergy = this.smaStratergy;
		let calculatedData = initialData;

		console.log('initialdata', initialData, calculatedData);

		const xScaleProvider = discontinuousTimeScaleProvider
			.inputDateAccessor(d => d.date);
		const {
			data,
			xScale,
			xAccessor,
			displayXAccessor,
		} = xScaleProvider(calculatedData);

		const start = xAccessor(last(data));
		const end = xAccessor(data[Math.max(0, data.length - 150)]);
		const xExtents = [start, end];

		const smaVolume50 = sma()
			.options({ windowSize: 20, sourcePath: "volume" })
			.merge((d, c) => { d.smaVolume50 = c; })
			.accessor(d => d.smaVolume50)
			.stroke("#4682B4")
			.fill("#4682B4");
		console.log('longAnnotationProps', longAnnotationProps, shortAnnotationProps, calculatedData, data);

		const rsiIndicator = this.state.rsiIndicator;
		// const rsiIndicator = true;
		const atrIndicator = this.state.atrIndicator;
		const macdIndicator = this.state.macdIndicator;
		const emaIndicator = this.state.emaIndicator;
		// const emaIndicator = false;
		const maIndicator = this.state.maIndicator;
		const bbIndicator = this.state.bbIndicator;
		const smaIndicator = this.state.smaIndicator;
		const fullStoIndicator = this.state.fullStoIndicator;
		const sarIndicator = this.state.sarIndicator;

		// const gridMargin = { left: 70, right: 70, top: 20, bottom: 30 };
		const gridMargin = margin;
		const gridHeight = height - gridMargin.top - gridMargin.bottom;
		const gridWidth = width - gridMargin.left - gridMargin.right;
		const showGrid = true;
		const zoomEvent = true;
		const yGrid = showGrid ? { innerTickSize: -1 * gridWidth, tickStrokeOpacity: 0.1 } : {};
		const xGrid = showGrid ? { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.1 } : {};

		let noOfDecimals = '.2f';
		if (data !== undefined && data.length !== undefined && data.length > 0 && parseFloat(data[0].close) < 1) {
			noOfDecimals = '.5f';
		}
		console.log('noOfDecimals', noOfDecimals, data);

		let showEmaStratergy, showMacdStratergy, showRsiStratergy, showSmaStratergy;
		console.log('indicators', rsiIndicator, atrIndicator, macdIndicator, emaIndicator, maIndicator, bbIndicator);

		//let supResLevels = getSupportResistance(data);
		console.log("Support Resistance", this.state.supResLevels);
		let chartSupResLevels;
		if (this.state.supResLevels === undefined || this.state.supResLevels.length <= 0) {
			chartSupResLevels = <></>;
		} else {
			chartSupResLevels = this.state.supResLevels.map(this.renderSupRes.bind(this));
		}

		//Draw Trendline
		console.log("Trendline", this.state.trendLineLevels);
		let chartTrendLineLevels;
		if (this.state.trendLineLevels === undefined || this.state.trendLineLevels.map === undefined || this.state.trendLineLevels.length <= 0) {
			chartTrendLineLevels = <></>;
		} else {
			chartTrendLineLevels = this.state.trendLineLevels.map(this.renderTrendLineLevels.bind(this));
		}

		const earningAnnotationProps = {
			fontFamily: "Glyphicons Halflings",
			fontSize: 20,
			fill: "black",
			opacity: 1,
			text: "E",
			y: ({ yScale }) => yScale.range()[0],
			// onClick: console.log.bind(console),
			// tooltip: d => timeFormat("%B")(d.date),
			tooltip: d => 'ER Date:' + d.label + '\nEstimate:' + d.estimatedEarning + '\nActual: ' + d.actualEarningResult,
			// onMouseOver: console.log.bind(console),
		};

		const dividendAnnotationProps = {
			fontFamily: "Glyphicons Halflings",
			fontSize: 20,
			fill: "black",
			opacity: 1,
			text: "$",
			y: ({ yScale }) => yScale.range()[0],
			// onClick: console.log.bind(console),
			// tooltip: d => timeFormat("%B")(d.date),
			tooltip: d => 'Div Date:' + d.label + '\nDividend:' + d.dividend,
			// onMouseOver: console.log.bind(console),
		};

		let showEma, showBb, showSma, showSar;
		if (emaIndicator) {
			showEma = <>
				<LineSeries yAccessor={emaLow.accessor()} stroke={emaLow.stroke()} />
				<LineSeries yAccessor={emaHigh.accessor()} stroke={emaHigh.stroke()} />
				<CurrentCoordinate yAccessor={emaLow.accessor()} fill={emaLow.stroke()} />
				<CurrentCoordinate yAccessor={emaHigh.accessor()} fill={emaHigh.stroke()} />
				<MovingAverageTooltip
					onClick={e => console.log(e)}
					origin={[-38, 15]}
					options={[
						{
							yAccessor: emaLow.accessor(),
							type: "EMA",
							stroke: emaLow.stroke(),
							windowSize: emaLow.options().windowSize,
						},
						{
							yAccessor: emaHigh.accessor(),
							type: "EMA",
							stroke: emaHigh.stroke(),
							windowSize: emaHigh.options().windowSize,
						},
					]}
				/>
			</>
		}

		if (smaIndicator) {
			showSma = <>
				<LineSeries yAccessor={smaLow.accessor()} stroke={smaLow.stroke()} />
				<LineSeries yAccessor={smaHigh.accessor()} stroke={smaHigh.stroke()} />
				<CurrentCoordinate yAccessor={smaLow.accessor()} fill={smaLow.stroke()} />
				<CurrentCoordinate yAccessor={smaHigh.accessor()} fill={smaHigh.stroke()} />
				<MovingAverageTooltip
					onClick={e => console.log(e)}
					origin={[-38, 15]}
					options={[
						{
							yAccessor: smaLow.accessor(),
							type: "SMA",
							stroke: smaLow.stroke(),
							windowSize: smaLow.options().windowSize,
						},
						{
							yAccessor: smaHigh.accessor(),
							type: "SMA",
							stroke: smaHigh.stroke(),
							windowSize: smaHigh.options().windowSize,
						},
					]}
				/>
			</>
		}

		if (bbIndicator) {
			showBb = <>
				<BollingerSeries yAccessor={d => d.bb}
					stroke={bbStroke}
					fill={bbFill} />
				<BollingerBandTooltip
					origin={[-38, 60]}
					yAccessor={d => d.bb}
					options={bb.options()} />
			</>
		}

		if (sarIndicator) {
			showSar = <>
				{/* <EdgeIndicator itemType="last" orient="right" edgeAt="right"
					yAccessor={d => d.close} fill={d => d.close > d.open ? "#6BA583" : "#FF0000"} /> */}
				<SARSeries yAccessor={d => d.sar} {...sarAppearance}/>
				<SingleValueTooltip
					yLabel={`SAR (${sarAccelerationFactor}, ${sarMaxAccelerationFactor})`}
					yAccessor={d => d.sar}
					origin={[-40, 20]} />
			</>
		}


		if (this.emaStratergy) {
			showEmaStratergy = <>
				<Annotate with={SvgPathAnnotation} when={d => d.emaLongShort === "LONG"}
					usingProps={longAnnotationProps} />
				<Annotate with={SvgPathAnnotation} when={d => d.emaLongShort === "SHORT"}
					usingProps={shortAnnotationProps} />
			</>
		}
		if (this.smaStratergy) {
			showSmaStratergy = <>
				<Annotate with={SvgPathAnnotation} when={d => d.smaLongShort === "LONG"}
					usingProps={longAnnotationProps} />
				<Annotate with={SvgPathAnnotation} when={d => d.smaLongShort === "SHORT"}
					usingProps={shortAnnotationProps} />
			</>
		}
		if (this.macdStratergy) {
			showMacdStratergy = <>
				<Annotate with={SvgPathAnnotation} when={d => d.macdLongShort === "LONG"}
					usingProps={longAnnotationProps} />
				<Annotate with={SvgPathAnnotation} when={d => d.macdLongShort === "SHORT"}
					usingProps={shortAnnotationProps} />
			</>
		}
		if (this.rsiStratergy) {
			showRsiStratergy = <>
				<Annotate with={SvgPathAnnotation} when={d => d.rsiLongShort === "LONG"}
					usingProps={longAnnotationProps} />
				<Annotate with={SvgPathAnnotation} when={d => d.rsiLongShort === "SHORT"}
					usingProps={shortAnnotationProps} />
			</>
		}



		return (
			<ChartCanvas height={height}
				width={width}
				ratio={ratio}
				mouseMoveEvent={true}
				panEvent={true}
				zoomEvent={true}
				clamp={false}
				margin={margin}
				type={type}
				seriesName={`MSFT_${this.state.suffix}`}
				data={data}
				xScale={xScale}
				xAccessor={xAccessor}
				displayXAccessor={displayXAccessor}
				xExtents={xExtents}>

				<Chart id={10} height={260}
					yExtents={[d => [d.high, d.low], emaLow.accessor(), emaHigh.accessor()]}
					padding={{ top: 10, bottom: 20 }}>
					<XAxis axisAt="bottom" orient="bottom" zoomEnabled={zoomEvent} {...xGrid} />

					{/* <Label x={(width - margin.left - margin.right) / 2} y={height - 45}
						fontSize="12" text="XAxis Label here" /> */}

					<YAxis axisAt="right" orient="right" ticks={5} zoomEnabled={zoomEvent} {...yGrid} />

					{/* <Label x={yAxisLabelX} y={yAxisLabelY}
						rotate={-90}
						fontSize="12" text="YAxis Label here" /> */}
					<MouseCoordinateX
						at="bottom"
						orient="bottom"
						displayFormat={timeFormat("%Y-%m-%d %H:%M:%S")} rectWidth={130} />
					<MouseCoordinateY
						at="right"
						orient="right"
						displayFormat={format(noOfDecimals)} rectWidth={80} />

					<CandlestickSeries />

					{showEma}
					{showBb}
					{showSma}
					{showSar}

					<EdgeIndicator itemType="last" orient="right" edgeAt="right" rectWidth={80}
						yAccessor={d => d.close} fill={d => d.close > d.open ? "#6BA583" : "#FF0000"} displayFormat={format(noOfDecimals)} />

					<OHLCTooltip origin={[-40, 0]} />

					{showEmaStratergy}
					{showMacdStratergy}
					{showRsiStratergy}
					{showSmaStratergy}

					{this.state.autoDrawSupRes ? chartSupResLevels : <></>}
					{this.state.autoDrawTrend ? chartTrendLineLevels : <></>}

					<Annotate with={LabelAnnotation} when={d => d.estimatedEarning !== undefined} usingProps={earningAnnotationProps} />
					<Annotate with={LabelAnnotation} when={d => d.dividend !== undefined} usingProps={dividendAnnotationProps} />

					<ZoomButtons onReset={this.handleReset} />
				</Chart>
				<Chart id={20} height={150}
					yExtents={[d => d.volume, smaVolume50.accessor()]}
					origin={(w, h) => [0, h - 410]}
				>
					<BarSeries yAccessor={d => d.volume} fill={d => d.close > d.open ? "#6BA583" : "#FF6666"} />
				</Chart>

				{/* RSI */}
				{rsiIndicator ? (
					<Chart id={30}
						yExtents={[0, 100]}
						height={150} origin={(w, h) => [0, h - 250]}
					>
						{/* <XAxis axisAt="bottom" orient="bottom" showTicks={true} outerTickSize={0} /> */}
						<YAxis axisAt="right"
							orient="right"
							tickValues={[30, 50, 70]} />
						<MouseCoordinateY
							at="right"
							orient="right"
							displayFormat={format(".2f")} />

						<RSISeries yAccessor={d => d.rsi} opacity={{ top: 0.5, middle: 0.5, bottom: 0.5 }}
							stroke={{ line: "#000000", outsideThreshold: "red", }}
						/>

						<RSITooltip origin={[-38, 15]}
							yAccessor={d => d.rsi}
							options={rsiCalculator.options()} />
					</Chart>
				) : <></>}

				{/* ATR */}
				{atrIndicator ? (
					<Chart id={40}
						yExtents={atr14.accessor()}
						height={60} origin={(w, h) => [0, h - 50]} padding={{ top: 10, bottom: 10 }}
					>
						<XAxis axisAt="bottom" orient="bottom" showTicks={false} />
						<YAxis axisAt="right" orient="right" ticks={2} />

						<MouseCoordinateX
							at="bottom"
							orient="bottom"
							displayFormat={timeFormat("%Y-%m-%d")} />
						<MouseCoordinateY
							at="right"
							orient="right"
							displayFormat={format(".2f")} />

						<LineSeries yAccessor={atr14.accessor()} stroke={atr14.stroke()} />
						<SingleValueTooltip
							yAccessor={atr14.accessor()}
							yLabel={`ATR (${atr14.options().windowSize})`}
							yDisplayFormat={format(".2f")}
							valueStroke={atr14.stroke()} /*- optional prop */
							labelStroke="#4682B4" /*- optional prop */
							origin={[-40, 15]} />
					</Chart>
				) : <></>}

				{/* MACD */}
				{macdIndicator ? (
					<Chart id={50} height={150}
						yExtents={macdCalculator.accessor()}
						origin={(w, h) => [0, h - 130]} padding={{ top: 10, bottom: 10 }}
					>
						{/* <XAxis axisAt="bottom" orient="bottom"/> */}
						<YAxis axisAt="right" orient="right" ticks={2} />

						<MouseCoordinateX
							at="bottom"
							orient="bottom"
							displayFormat={timeFormat("%Y-%m-%d")}
							rectRadius={5}
							{...mouseEdgeAppearance}
						/>
						<MouseCoordinateY
							at="right"
							orient="right"
							displayFormat={format(".2f")}
							{...mouseEdgeAppearance}
						/>

						<MACDSeries yAccessor={d => d.macd}
							{...macdAppearance} />
						<MACDTooltip
							origin={[-38, 30]}
							yAccessor={d => d.macd}
							options={macdCalculator.options()}
							appearance={macdAppearance}
						/>
					</Chart>
				) : <></>}

				{/* Stochastic */}
				{fullStoIndicator ? (
					<Chart id={60}
						yExtents={[0, 100]}
						height={125} origin={(w, h) => [0, h - 125]} padding={{ top: 10, bottom: 10 }}
					>
						{/* <XAxis axisAt="bottom" orient="bottom" {...xGrid} /> */}
						<YAxis axisAt="right" orient="right"
							tickValues={[20, 50, 80]} />

						<MouseCoordinateX
							at="bottom"
							orient="bottom"
							displayFormat={timeFormat("%Y-%m-%d")} />
						<MouseCoordinateY
							at="right"
							orient="right"
							displayFormat={format(".2f")} />
						<StochasticSeries
							yAccessor={d => d.fullSTO}
							{...stoAppearance} />

						<StochasticTooltip
							origin={[-38, 15]}
							yAccessor={d => d.fullSTO}
							options={fullSTO.options()}
							appearance={stoAppearance}
							label="Full STO" />
					</Chart>
				) : <></>}

				<CrossHairCursor />
			</ChartCanvas>
		);
	}
}

//  <LineSeries yAccessor={d => d.close} stroke="#000000" /> 


ChartAlgo.propTypes = {
	data: PropTypes.array.isRequired,
	width: PropTypes.number.isRequired,
	ratio: PropTypes.number.isRequired,
	type: PropTypes.oneOf(["svg", "hybrid"]).isRequired,
};

ChartAlgo.defaultProps = {
	type: "svg",
};

ChartAlgo = fitWidth(ChartAlgo);

export default ChartAlgo;
